// extracted by mini-css-extract-plugin
module.exports =  {"CommentList":"jGspjeUI48FdyJ1JgAmr","Comment":"Jy9kDtS2HX64SbSEy1bJ"};